import { Typography, colors } from '@mui/material'
import { styled } from '@mui/material/styles'

const GreyTypography = styled(Typography)(() => ({
  color: colors.grey['A700'],
}))

export default GreyTypography
